import { msToTicks, noteDivisionToMs, noteDivisionToTicks, quarterNoteMs, ticksToMs } from '../../stores/synthTiming.js'

export { noteDivisionToMs, noteDivisionToTicks, ticksToMs, msToTicks }

export function beatsToMs(beats, bpm) {
  const quarterMs = quarterNoteMs(bpm)
  return Number(beats) * quarterMs
}

export function msToBeats(ms, bpm) {
  const quarterMs = quarterNoteMs(bpm)
  return Number(ms) / quarterMs
}

export function snapDurationMs(durationMs, bpm, division, minDivisions = 1) {
  const step = noteDivisionToMs(division, bpm)
  const units = Math.max(minDivisions, Math.round(Number(durationMs) / step))
  return clampPositiveMs(units * step)
}

export function formatDivision(division) {
  return ['1/4', '1/8', '1/16', '1/32'].includes(String(division)) ? String(division) : '1/16'
}

export function closestDivisionLabel(durationTicks) {
  const divisions = ['1/4', '1/8', '1/16', '1/32']
  const target = Number(durationTicks)
  let best = divisions[0]
  let bestDistance = Number.POSITIVE_INFINITY
  for (const division of divisions) {
    const ticks = noteDivisionToTicks(division)
    const distance = Math.abs(target - ticks)
    if (distance < bestDistance) {
      bestDistance = distance
      best = division
    }
  }
  return best
}

function clampPositiveMs(value) {
  return Math.max(1, Math.round(Number(value) || 0))
}
